module.exports = __webpack_public_path__ + "img/hiso-bus-rental-bg-homepage.2e8f998f.jpg";